module.exports = require("./ng-file-upload.js");


//////////////////
// WEBPACK FOOTER
// ng-file-upload (bower component)
// module id = 1476
// module chunks = 0